import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { AuthenticationContext } from 'services/context/authentication.context';
import { IdCreditRequestModal } from '../modals/id-credit-request/IdCreditRequestModal';

export function DashboardIdCredit() {

  const { state } = useContext(AuthenticationContext);
  const [canRequestIdCredit, setCanRequestIdCredit] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  useEffect(() => {
    if (state.user !== null && state.customer !== null) {
      setCanRequestIdCredit(state.customer.isPerson && state.user.canRequestIdCredit);
    }

  }, [state.user, state.customer]);

  return (
    <>
      { 
        canRequestIdCredit ?
          <Card className='d-flex flex-row flex-nowrap align-items-center justify-content-between p-4 mb-4'>
            <div className='d-flex align-items-center'>
              <i className='icon__id-credit mr-2'></i>
              <strong className='u-fs-16'>ID-kaart krediitkaardiks!</strong>
            </div>
            <button 
              className="btn btn-secondary-medium d-flex align-items-center"
              onClick={() => setModalVisible(true)}
            >Taotle <i className='icon__arrow-right bg-dark ml-2'></i></button>
          </Card>
 :
          null
      }
      {
        isModalVisible ?
          <IdCreditRequestModal
            handleConfirmReject={() => setModalVisible(false)}
            handleConfirmSubmit={() => {setModalVisible(false); setCanRequestIdCredit(false);}}
          /> :
        null
      }
    </>
  )
}